/**
 * Firebase Collection Names
 * Centralized collection name constants to avoid typos and enable refactoring
 */

export const COLLECTIONS = {
  // Core entities
  JOBS: 'jobs',
  CUSTOMERS: 'customers',
  VEHICLES: 'vehicles',
  EMPLOYEES: 'employees',

  // Inventory & Procurement
  INVENTORY: 'inventory',
  STOCK: 'stock',
  MOVEMENTS: 'movements',
  STOCK_MOVEMENTS: 'stockMovements',
  PROCUREMENTS: 'procurements',
  PURCHASE_ORDERS: 'purchaseOrders',
  SUPPLIERS: 'suppliers',
  GRN: 'grn',
  GOODS_RECEIVED_NOTES: 'goodsReceivedNotes',
  MARGIN_SETTINGS: 'marginSettings',

  // Financial
  INVOICES: 'invoices',
  NEW_INVOICES: 'newInvoices',
  QUOTATIONS: 'quotations',
  TRANSACTIONS: 'transactions',
  PAYABLES: 'payables',
  TAXES: 'taxes',

  // Operations
  TASKS: 'tasks',
  SERVICES: 'services',
  CONTRACTORS: 'contractors',
  APPOINTMENTS: 'appointments',
  ALLOCATIONS: 'allocations',
  TECHNICIANS: 'technicians',

  // Feedback & Support
  FEEDBACK: 'feedback',
  FEEDBACKS: 'feedbacks',
  ARTICLES: 'articles',

  // HR & Management
  LEAVE_REQUESTS: 'leaveRequests',
  PERFORMANCE_REVIEWS: 'performanceReviews',

  // System
  ROLES: 'roles',
  PERMISSIONS: 'permissions',
  FEATURES: 'features',
  AGENTS: 'agents',
  EVENT_LOGS: 'eventLogs',
};

export default COLLECTIONS;
